var _g, _g2, _g3, _g4, _g5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "calendar",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1757",
    "data-name": "Group 1757"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1756",
    "data-name": "Group 1756"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2997",
    "data-name": "Path 2997",
    d: "M22.07,1.953H20.9V0H18.945V1.953H6.055V0H4.1V1.953H2.93A2.933,2.933,0,0,0,0,4.883V22.07A2.933,2.933,0,0,0,2.93,25H22.07A2.933,2.933,0,0,0,25,22.07V4.883A2.933,2.933,0,0,0,22.07,1.953Zm.977,20.117a.978.978,0,0,1-.977.977H2.93a.978.978,0,0,1-.977-.977V9.18H23.047Zm0-14.844H1.953V4.883a.978.978,0,0,1,.977-.977H4.1V5.859H6.055V3.906H18.945V5.859H20.9V3.906H22.07a.978.978,0,0,1,.977.977Z",
    fill: "#5066e7"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1761",
    "data-name": "Group 1761",
    transform: "translate(7.584 11.841)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1760",
    "data-name": "Group 1760"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_928",
    "data-name": "Rectangle 928",
    width: 2.198,
    height: 2.473,
    fill: "#5066e7"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1765",
    "data-name": "Group 1765",
    transform: "translate(15.129 11.841)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1764",
    "data-name": "Group 1764"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_930",
    "data-name": "Rectangle 930",
    width: 2.473,
    height: 2.473,
    fill: "#5066e7"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1779",
    "data-name": "Group 1779",
    transform: "translate(7.584 18.095)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1778",
    "data-name": "Group 1778"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_937",
    "data-name": "Rectangle 937",
    width: 2.198,
    height: 2.473,
    fill: "#5066e7"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1783",
    "data-name": "Group 1783",
    transform: "translate(15.129 18.095)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1782",
    "data-name": "Group 1782"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_939",
    "data-name": "Rectangle 939",
    width: 2.473,
    height: 2.473,
    fill: "#5066e7"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDate);
export default __webpack_public_path__ + "static/media/icon-date.66f81875d931a61ab7dd518485d68bc2.svg";
export { ForwardRef as ReactComponent };